module.exports = __webpack_public_path__ + "img/pos_s3_img2.5410a342.png";